declare const THREE: any;

export class ColorInterpolation {

  private start;
  private end;
  private startValue: number;
  private endValue: number;

  constructor(start, end) {
    this.start = start;
    this.end = end;
    this.startValue = start.getHex();
    this.endValue = end.getHex();
  }

  getStart(): number {
    return this.startValue;
  }

  getEnd(): number {
    return this.endValue;
  }

  interpolate(interpolation: number) {
    this.start.setHex(this.startValue);
    this.end.setHex(this.endValue);
    return this.start.lerp(
      this.end,
      interpolation
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/classes/ColorInterpolation.ts